import { Component, Output, EventEmitter, Input } from '@angular/core';
import { Router } from '@angular/router';
import { MobileNavbarService } from '../../core/mobile-navbar.service';
import { CommonModule } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
]
})
export class NavbarComponent {
  @Output() menuToggle = new EventEmitter<void>();
  @Input() showMenuButton = true;

  backLink = toSignal(this.mobileNavbar.backLink$);

  constructor(
    public mobileNavbar: MobileNavbarService,
    private router: Router
  ) {}

  goBack() {
    const backLink= this.backLink();
    if (Array.isArray(backLink)) {
      this.router.navigate(backLink);
    }
  }

  onMenuToggle() {
    this.menuToggle.emit();
  }
}
